import React from "react";
import { useNavigate } from "react-router-dom";
import { AuthHeader } from "../../components/AuthHeader";
import checkIcon from "../../../../assets/login/tick.png";

const ResetPasswordConfirmation: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            <AuthHeader />
            <div className="flex flex-col items-center flex-1 bg-gray-50 p-5">
                <div className="bg-white sm:w-2/5 max-w-xl py-10 px-8 rounded-lg shadow-sm flex flex-col items-center animate-in fade-in zoom-in duration-300">
                    {/* Tick Icon */}
                    <img
                        src={checkIcon}
                        alt="Success"
                        className="w-20 h-20 mb-4"
                    />

                    {/* Title */}
                    <h2 className="text-2xl font-bold text-gray-800 text-center mt-2 mb-2">
                        Check Your Email
                    </h2>

                    {/* Subtitle */}
                    <p className="text-base font-medium text-gray-800 text-center">
                        We've sent a link to reset your password
                    </p>

                    <button
                        onClick={() => navigate("/")}
                        className="mt-8 text-indigo-600 font-semibold hover:text-indigo-700 transition-colors"
                    >
                        Back to login
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordConfirmation;
